import Box from '@mui/material/Box';
import { useProfile } from 'src/helpers/use';

import FindTrainingCourseSection from '@components/organisms/cpdLandingPage/FindTrainingCourseSection';
import Heading from '@components/organisms/cpdLandingPage/heading';
import HowToTrainSection from '@components/organisms/cpdLandingPage/howToTrainSection';
import QualityCourseSection from '@components/organisms/cpdLandingPage/qualityCourseSection';
import RecommendedSection from '@components/organisms/cpdLandingPage/recommendedSection';
import RegulatorSection from '@components/organisms/cpdLandingPage/regulartorSection';
import WhatIsTrainingSection from '@components/organisms/cpdLandingPage/whatIsTrainingSection';
import WhySkilllaneCpdSection from '@components/organisms/cpdLandingPage/whySkilllaneCpdSection';

const CpdLanding = () => {
  const { profile } = useProfile();

  return (
    <>
      <Heading cpdCitizenId={profile?.cpd_citizen_id!} />
      {/* TODO: maybe bring back in the future */}
      {/* {profile?.cpd_citizen_id && <RecommendedSection cpdCitizenId={profile?.cpd_citizen_id} />} */}
      <Box>
        <RegulatorSection />
        <QualityCourseSection />
        <WhatIsTrainingSection />
        <WhySkilllaneCpdSection />
        <HowToTrainSection />
        <FindTrainingCourseSection profileCPD={!!profile?.cpd_citizen_id} />
      </Box>
    </>
  );
};

export default CpdLanding;
